/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum OperationsTaskType {
  BookPickup = "book_pickup",
  MissedPickup = "missed_pickup",
  ChangePickupDate = "change_pickup_date",
  ChangeDeliveryHours = "change_delivery_hours",
  ExpectedDeliveryIsInThePast = "expected_delivery_is_in_the_past",
  TrackingNotUpdated = "tracking_not_updated",
  MissedDelivery = "missed_delivery",
  MissingFreight = "missing_freight",
  CancelShipment = "cancel_shipment",
  ChangeBroker = "change_broker",
  ChangeShipmentAddress = "change_shipment_address",
  ChangeShipmentContact = "change_shipment_contact",
  ChangeShipmentReferenceAndNotes = "change_shipment_reference_and_notes",
  MarkOnHold = "mark_on_hold",
  CreditCardPaymentNeedsAction = "credit_card_payment_needs_action",
  PickupCheckins = "pickup_checkins",
  MissingProNumber = "missing_pro_number",
}

export function instanceOfOperationsTaskType(value: any): boolean {
  for (const key in OperationsTaskType) {
    if (Object.prototype.hasOwnProperty.call(OperationsTaskType, key)) {
      if (
        OperationsTaskType[key as keyof typeof OperationsTaskType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OperationsTaskTypeFromJSON(json: any): OperationsTaskType {
  return OperationsTaskTypeFromJSONTyped(json, false);
}

export function OperationsTaskTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationsTaskType {
  return json as OperationsTaskType;
}

export function OperationsTaskTypeToJSON(
  value?: OperationsTaskType | null,
): any {
  return value as any;
}

export function OperationsTaskTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OperationsTaskType {
  return value as OperationsTaskType;
}
